const COLORS = {
    LOADING_COMPONENT: "hsl(139deg 68% 37%)",
    ACTIVITY_COLOR: ['#F1686E', '#F3BA67', '#EDE555', '#AFDBAF', '#A3EEE9', '#BBCCEA', '#EEAFDF'],
    STATE_EVENT_COLOR: ['#fff', '#99D799', '#A1C1F9', '#d0d0d0', '#fff', '#ebdd91', '#fff']
};
export default COLORS;
